export default "__VITE_ASSET__BB6hOt70__"